import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { PASS_THROUGH } from '@attain-apps/transformers'
import gql from 'graphql-tag'

const DOC = gql`
  query SpaceUnassignedSponsoredPeoplePayrollsCount(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $filter: SpacePayrollsFilterInput
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceUnassignedSponsoredPayrollsCount(filter: $filter)
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.SpaceUnassignedSponsoredPeoplePayrollsCountQuery,
    number,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'spaceUnassignedSponsoredPayrollsCount',
                PASS_THROUGH,
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  0,
)

export const executor = graphql.createExecutor<
  graphql.schema.SpaceUnassignedSponsoredPeoplePayrollsCountQuery,
  number,
  graphql.schema.SpaceUnassignedSponsoredPeoplePayrollsCountQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
